import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'
const helpers = createMultiStyleConfigHelpers([
    'details',
    'ingredientsMenu',
    'stepsMenu',
    'productSuggestion',
])
const RecipeDetails = helpers.defineMultiStyleConfig({
    baseStyle: {
        details: {
            detailsContainer: {
                w: '100%',
                flexDir: 'column',
                alignItems: 'center',
            },
            breadcrumbsContainer: {
                w: '100%',
                paddingX: {
                    base: 'small.lg',
                    lg: remCalc(260),
                },
                h: 'auto',
                paddingTop: {
                    base: 'small.base',
                    lg: 'small.lg',
                },
            },
            recipeInfoContainer: {
                flexDir: {base: 'column', lg: 'row'},
                w: '100%',
                alignItems: 'stretch',
                borderTop: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
        },
        ingredientsMenu: {
            outerContainer: {
                bg: 'background.light-dark',
                width: {base: '100%', lg: '50%'},
            },
            stickyContainer: {
                position: {
                    base: 'unset',
                    lg: 'sticky',
                },
                bg: 'background.light-dark',
                top: {base: 'large.lg', lg: 0},
                w: {
                    base: '100%',
                    lg: '100%',
                },
                height: 'auto',
                padding: {
                    base: 'small.base',
                    lg: 'large.lg',
                },
                paddingLeft: {
                    base: 'small.base',
                    lg: remCalc(260),
                },
            },
            ingredientsTitle: {
                paddingBottom: 'large.base',
                alignSelf: 'stretch',
                textStyle: 'head-medium',
                fontWeight: 'semibold',
            },
            servingsContainer: {
                w: '50%',
                paddingBottom: 'large.base',
                flexDir: 'column',
            },
            ingredientMenuTitle: {
                color: 'text.default',
                alignSelf: 'stretch',
                textStyle: 'head-xsmall',
                fontWeight: 'semibold',
                marginBottom: 'medium.base',
            },
            ingredientText: {
                alignSelf: 'stretch',
                textStyle: 'body-medium',
            },
            ingredientContainer: {
                w: '100%',
                paddingBottom: 'large.base',
                flexDir: 'column',
            },
        },
        stepsMenu: {
            stepsContainer: {
                w: {
                    base: '100%',
                    lg: '50%',
                },
                padding: {base: 'small.base', lg: 'large.lg'},
                paddingTop: {base: 'small.base', lg: 'xlarge.base'},
                paddingRight: {base: 'small.base', lg: remCalc(260)},
            },
            stepsTitle: {
                textStyle: 'head-medium',
                fontWeight: 'semibold',
                paddingBottom: 'large.base',
            },
            stepContainer: {
                w: '100%',
                flexDir: 'column',
                gap: 'medium.base',
                paddingBottom: 'medium.lg',
            },
            stepImageContainer: {
                w: '100%',
                h: 'auto',
            },
            stepNumber: {
                textStyle: 'head-xmsall',
                fontWeight: 'medium',
            },
        },
        productSuggestion: {
            suggestionsContainer: {
                maxW: {
                    base: remCalc(343),
                    sm: remCalc(343),
                    md: remCalc(343),
                    large: 'unset',
                },
                gap: {
                    base: 'medium.base',
                    lg: '0',
                },
                flexDir: {
                    base: 'column',
                    sm: 'column',
                    md: 'column',
                    lg: 'row',
                },
                width: '100%',
                alignItems: {
                    base: 'center',
                    sm: 'center',
                    md: 'center',
                    lg: 'start',
                },
                paddingBottom: {
                    base: 'xsmall.base',
                    sm: 'xsmall.sm',
                    md: 'small.md',
                    lg: 'large.lg',
                },
                paddingTop: {
                    base: 'medium.base',
                    sm: 'medium.sm',
                    md: 'medium.md',
                    lg: 'large.lg',
                },
            },
            maidWithContainer: {
                flexDir: 'column',
                h: 'auto',
                paddingX: 'small.lg',
            },
            textBoxTileContainer: {
                flexDir: 'column',
                h: '100%',
                minW: {base: 'unset', lg: 'xlarge.large'},
                paddingTop: {
                    base: 'medium.base',
                    sm: 'medium.base',
                    md: 'medium.base',
                    lg: 'large.lg',
                },
                paddingRight: {
                    base: 'medium.base',
                    sm: 'medium.base',
                    md: 'medium.base',
                    lg: ' large.base ',
                },
                paddingBottom: {
                    base: 'medium.base',
                    sm: 'medium.base',
                    md: 'medium.base',
                    lg: 'large.base ',
                },
                paddingLeft: {
                    base: 'medium.base',
                    sm: 'medium.base',
                    md: 'medium.base',
                    lg: '0',
                },
            },
            textBoxTitleText: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 'semibold',
                marginBottom: 'medium.base',
                minW: {base: 'unset', lg: 'xlarge.large'},
                textAlign: {base: 'center', lg: 'unset'},
            },
            textBoxBodyText: {
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 'semibold',
                maxW: {base: 'unset', lg: remCalc(200)},
                minW: {base: 'unset', lg: 'xlarge.large'},
                textAlign: {base: 'center', lg: 'unset'},
            },
        },
    },
})

export default RecipeDetails
